import { Pipe, PipeTransform } from '@angular/core';

import { Option } from '@eiq/ui';

import { Operator, OperatorByQuestionType, QuestionType, RatingType } from '@empathy/survey/base';
import { OperatorText, Question } from '@empathy/survey-core';

@Pipe({
  name: 'operatorByType',
  pure: false
})
export class OperatorByTypePipe implements PipeTransform {
  transform(question: Question, optionId: string | null = null): Option<string>[] {
    const operatorsAllowed: Operator[] = this.mapOperatorsAllowedByQuestionType(question, optionId);
    const operatorOptions: Option<string>[] = [];

    for (const operator in OperatorText) {
      if (Object.prototype.hasOwnProperty.call(OperatorText, operator) && operatorsAllowed.includes(operator as Operator)) {
        operatorOptions.push({
          value: operator,
          text: OperatorText[operator]
        });
      }
    }

    return operatorOptions;
  }

  private mapOperatorsAllowedByQuestionType(question: Question, optionId: string | null): Operator[] {
    switch (question.type) {
      case QuestionType.Input:
        return OperatorByQuestionType[question.type][question.inputType] || OperatorByQuestionType[question.type]['default'];
      case QuestionType.Rating:
      case QuestionType.CarouselRating:
        return question.ratingType === RatingType.descriptive
          ? OperatorByQuestionType[question.type]['descriptive']
          : OperatorByQuestionType[question.type]['default'];
      case QuestionType.RankSort:
        if (!!optionId && optionId === 'NONE') {
          return OperatorByQuestionType[question.type]['none'];
        }
        if (question.ratingType === RatingType.descriptive) {
          return OperatorByQuestionType[question.type]['descriptive'];
        } else {
          return OperatorByQuestionType[question.type]['default'];
        }
      default:
        return OperatorByQuestionType[question.type]['default'];
    }
  }
}
